"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Oct 22 2018
 */

var CompetitorPriceHistoryIndexDTO_1 = require("../../../cleaning/model/dto/CompetitorPriceHistoryIndexDTO");

var CompetitorPriceHistoryIndexDTOConverter_1 = require("./CompetitorPriceHistoryIndexDTOConverter");
/**
 * Implementation of CompetitorPriceHistoryIndexDTOConverter
 *
 * @author RV
 */


var CompetitorPriceHistoryIndexDTOConverterImpl =
/*#__PURE__*/
function (_CompetitorPriceHisto) {
  _inherits(CompetitorPriceHistoryIndexDTOConverterImpl, _CompetitorPriceHisto);

  function CompetitorPriceHistoryIndexDTOConverterImpl() {
    _classCallCheck(this, CompetitorPriceHistoryIndexDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceHistoryIndexDTOConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorPriceHistoryIndexDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new CompetitorPriceHistoryIndexDTO_1.CompetitorPriceHistoryIndexDTO(source.competitorPriceId, source.priceChangeIndex ? conversions.toBigNumber(source.priceChangeIndex) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        competitorPriceId: source.competitorPriceId,
        priceChangeIndex: source.priceChangeIndex ? conversions.fromBigNumber(source.priceChangeIndex) : null
      });
      return result;
    }
  }]);

  return CompetitorPriceHistoryIndexDTOConverterImpl;
}(CompetitorPriceHistoryIndexDTOConverter_1.CompetitorPriceHistoryIndexDTOConverter);

exports.CompetitorPriceHistoryIndexDTOConverterImpl = CompetitorPriceHistoryIndexDTOConverterImpl;